import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-dialog-privacy',
  templateUrl: './dialog-privacy.component.html',
  styleUrls: ['./dialog-privacy.component.css']
})
export class DialogPrivacy {
  presoVisione: boolean = false;
  constructor(public dialogRef: MatDialogRef<DialogPrivacy>,
    @Inject(MAT_DIALOG_DATA) public data:boolean) 
  {
    this.presoVisione = data;
  }

  close(){
    this.dialogRef.close( 
      {presoVisione: this.presoVisione}
    );
  }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-privacy/dialog-privacy.component.ts